import React from "react"
import PropTypes from "prop-types"

import styles from "./styles.css"

const SpinnerLoad = ({ isButton, personalStyle }) => {
  return (
    <div
      className={`${styles.loader} ${isButton && styles.loader_button}`}
      style={isButton && personalStyle}
    />
  )
}

SpinnerLoad.propTypes = {
  isButton: PropTypes.bool,
  personalStyle: PropTypes.object
}

export default SpinnerLoad



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/SpinnerLoad/index.js